<template>
	<div class="link-wrapper" :class="'el-'+details.id" :style="containerStyle">
		<v-style>
			{{css}}
			{{ hoverStyle }}
		</v-style>
		<a
				:href="linkUrl"
				:target="linkTarget"
				:id="advanced.cssId"
				:class="['link', advanced.cssClasses, responsiveClasses]"
				:style="style">
			{{ basic.content || 'Link' }}
		</a>
	</div>
</template>

<script>
import {
	borderProps,
	boxShadow,
	fontProps,
	textShadow,
	getPadding,
	responsiveAlignStyles, multiTextShadow, getAlignment
} from "@/modules/page-editor/src/utils/props";
import {linkTarget, linkUrl} from "@/helpers/actionData";

export default {
	name: 'EmailLink',
	props: ['details'],
	computed: {
		basic() {
			return this.details.attributes.basic
		},
		advanced() {
			return this.details.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		linkUrl() {
			return linkUrl(this.basic.linkUrl);
		},
		linkTarget() {
			return linkTarget(this.basic.linkUrl);
		},
		hoverStyle() {
			let color = this.basic.hoverColor ? this.basic.hoverColor + ' !important' : 'initial';

			return ('.el-' + this.details.id + ' a:hover { color: ' + color + ';}');
		},
		css() {
			return responsiveAlignStyles(this.basic.align, this.details.id);
		},
		containerStyle() {
			return {
				margin: getPadding(this.basic.margin),
				padding: getPadding(this.advanced.padding),
				boxShadow: boxShadow(this.advanced.shadows),
				...borderProps(this.advanced.border),
			}
		},
		/* Use 'null' instead of 'false' as default value to unset/remove the property. */
		style() {

			return {
				...fontProps(this.basic.font),
				textShadow: multiTextShadow(this.basic.textShadows),
				// No need for background-color, users can use "button" instead.
				// backgroundColor: this.basic.backgroundColor || null,
			};
		}
	},
}
</script>
